import { render, staticRenderFns } from "./MultiscanBox.vue?vue&type=template&id=4b41a4a3&scoped=true&"
import script from "./MultiscanBox.vue?vue&type=script&lang=js&"
export * from "./MultiscanBox.vue?vue&type=script&lang=js&"
import style0 from "./MultiscanBox.vue?vue&type=style&index=0&id=4b41a4a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b41a4a3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
